import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import { Button } from 'ui-components/components/button';
import { AutoBatchingContext } from '../context';
import style from '../style.module.less';

const ConfirmMoveMessage = () => {
  const { totalRecords, totalAlreadyBatched, onHasConfirmedForceMove, onHasExcludedFulfillmentPlanIds } = useContext(AutoBatchingContext);
  const shouldShowRemoveButton = totalRecords !== totalAlreadyBatched;

  return (
    <>
      <FormattedMessage
        {...messages.autoBatchingOrdersIncludedInAnotherBatch}
        values={{
          totalAlreadyBatched,
          b: (chunks) => <span className={style['part-bolder']}>{chunks}</span>,
        }}
      />
      <div className={style['confirm-move-actions']}>
        <Button onClick={onHasConfirmedForceMove}>
          <FormattedMessage {...messages.confirmMoveButton} />
        </Button>
        {shouldShowRemoveButton && (
          <Button className={style['exclude-button']} onClick={onHasExcludedFulfillmentPlanIds} theme='link'>
            <FormattedMessage {...messages.removeFromSelectedOrders} />
          </Button>
        )}
      </div>
    </>
  );
};

export { ConfirmMoveMessage };
